module.exports = __webpack_public_path__ + "prueba.74d1a03156e1ad36104c.png";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/images/prueba.png
// module id = ../../../../../src/assets/images/prueba.png
// module chunks = main